import React from 'react';
import { useFeatureFlagContext } from '@fff-web/feature-flags';
import { SUBSCRIPTION_PRICE_INCREASES } from '@fff-web/fff-utilities';
import useSubscriptionPlanPrices from '../../../hooks/useSubscriptionPlanPrices';
import styles from './UpgradeDisclaimer.module.scss';

const UpgradeDisclaimer = () => {
  const { annualPrice } = useSubscriptionPlanPrices();
  const flags = useFeatureFlagContext();
  const disclaimerPriceIncreaseFF = flags?.disclaimerPriceIncrease;

  if (!annualPrice) return null;

  return (
    <div className={styles.upgradeDisclaimerContainer}>
      By clicking &quot;YES, UPGRADE ME&quot;, you authorize us to charge $
      {annualPrice} USD, minus any applicable discount, to the payment method on
      file immediately for an annual subscription. Your annual subscription will
      continue until cancelled and you will be charged $
      {disclaimerPriceIncreaseFF
        ? SUBSCRIPTION_PRICE_INCREASES.annual
        : annualPrice}
      /year starting on the annual bill date following receipt of your next 4
      boxes. Sales tax will also be charged, where applicable. Shipping charges
      of $8 USD per box applies for shipping to Canada, Hawaii, Alaska and
      Puerto Rico ($10 USD/box for UK). Foreign exchange or transaction fees may
      apply for non-US customers. Cancel anytime before your next bill date.
      <br />
      <br />
      *Savings based on comparison to Seasonal Subscription price for four
      boxes. Free shipping in the contiguous US only.
    </div>
  );
};

export default UpgradeDisclaimer;
